module.exports = __webpack_public_path__ + "static/milli-piyango-case-study-065440a830c37a001936711b269fbe54.webp";